import React from 'react';
import { useCompany } from '../contexts/CompanyContext';
import { getTrialDaysRemaining } from '../lib/trial';

function pluralizeDays(n) {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) return 'день';
  if ([2, 3, 4].includes(mod10) && ![12, 13, 14].includes(mod100)) return 'дня';
  return 'дней';
}

export default function TrialBanner() {
  const { currentCompany } = useCompany();
  const daysRemaining = getTrialDaysRemaining(currentCompany);

  if (daysRemaining === null) return null;

  const expired = daysRemaining <= 0;
  const urgent = daysRemaining <= 3;

  return (
    <div
      className={
        'px-4 py-2 text-sm text-center font-medium ' +
        (expired
          ? 'bg-red-600 text-white'
          : urgent
          ? 'bg-amber-100 text-amber-900'
          : 'bg-blue-50 text-blue-800')
      }
      data-testid="trial-banner"
    >
      {expired
        ? 'Пробный период закончился. Доступны только Дашборд и Отчёты — оформите подписку, чтобы вернуть полный доступ.'
        : `Пробный период: осталось ${daysRemaining} ${pluralizeDays(daysRemaining)}.`}
    </div>
  );
}
